import React from "react";
import {CaptchaProvider} from "@unibuddy/captcha";
import {getApolloClientReferrer} from "../../util/referrer";
import {getenv} from "../../util/getEnv";

const RECAPTCHA_SITE_KEY_WEB = getenv("RECAPTCHA_SITE_KEY_WEB");

export function Captcha({children}: {children: React.ReactNode}) {
    const clientName = getApolloClientReferrer(window.location.pathname);

    return (
        <CaptchaProvider siteKey={RECAPTCHA_SITE_KEY_WEB} clientName={clientName}>
            {children}
        </CaptchaProvider>
    );
}
